import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

onDomReady(() => {
   Leaderboard.initialize();
});

// eslint-disable-next-line no-var
export var Leaderboard = (window.Leaderboard = {
   ALL_TIME: 'all-time',
   MONTH: 'month',
   WEEK: 'week',
   DAY: 'today',

   initialize: function () {
      this.filterOptions = $$('.time-container a.filter-option');
      let leaderboardFilterOptions = $E('.filter-items');

      this.currentFilter = leaderboardFilterOptions
         ? leaderboardFilterOptions.get('data-filterby')
         : WEEK;

      // Make sure currentFilter is a valid option
      if (![this.ALL_TIME, this.MONTH, this.WEEK, this.DAY].contains(this.currentFilter)) {
         this.currentFilter = this.WEEK;
      }

      this.filterOptions.each(option => {
         option.addEvent('click', this.updateFilterOption.bind(this, option));

         let filterName = option.get('data-timeFilter');
         if (filterName == this.currentFilter) {
            option.addClass('filter-option-active');
         }
      });

      $('content').addEvents({
         'click:relay(.js-toggle-selected)': function (ev, el) {
            $$('.js-toggle-target').removeClass('toggle-open');
            $$('.js-toggle-selected').removeClass('selected');

            let target = el.getParent().getElement('.js-toggle-target');
            target.toggleClass('toggle-open');
         },
         'click:relay(.js-toggle-target)': function (ev, el) {
            $$('.js-toggle-target').removeClass('toggle-open');
            $$('.js-toggle-selected').removeClass('selected');
         },
      });

      this.updateDateTitle();
      this.updateMobileTabLabels();
   },

   updateMobileTabLabels: function () {
      let filterName = $E('.filter-option-active').get('text');
      $E('.js-current-filter-name').set('text', filterName);
   },

   // Updates page title date for ranged values
   replaceDateTitle: function (startDate, today) {
      const dateFormatter = new Intl.DateTimeFormat('default', {
         dateStyle: 'medium',
      });

      let startStr = dateFormatter.format(startDate);
      let endStr = dateFormatter.format(today);
      $('title-date').update(startStr + ' - ' + endStr);
   },

   updateDateTitle: function () {
      let today = new Date();
      let startDate = new Date();
      const dateFormatter = new Intl.DateTimeFormat('default', {
         dateStyle: 'full',
      });

      switch (this.currentFilter) {
         case this.MONTH: {
            startDate.setMonth(startDate.getMonth() - 1);
            this.replaceDateTitle(startDate, today);
            break;
         }
         case this.WEEK: {
            startDate.setDate(startDate.getDate() - 7);
            this.replaceDateTitle(startDate, today);
            break;
         }
         case this.DAY: {
            $('title-date').update(dateFormatter.format(today));
            break;
         }
         default: {
            $('title-date').update('');
            break;
         }
      }
   },

   updateFilterOption: function (option) {
      if (option.hasClass('filter-option-active')) {
         return;
      } else {
         $('loadingSpinner').set(
            'src',
            window.shared_constants.BaseURI('SITE_IMAGE_BLURBS_LOADING')
         );

         this.filterOptions.invoke('removeClass', 'filter-option-active');
         option.addClass('filter-option-active');
         this.currentFilter = $E('.filter-option-active').get('data-timeFilter');

         // Map filter values to display names for tracking
         const filterNames = {
            'all-time': 'All Time',
            month: 'Month',
            week: 'Week',
            today: 'Today',
         };
         const filterDisplayName = filterNames[this.currentFilter] || this.currentFilter;

         trackAnalyticsCustomEvent({
            eventCategory: 'Leaderboard',
            eventAction: `Leaderboard - Filter - ${filterDisplayName}`,
         });

         this.updateDateTitle();
      }

      let config = {
         timePeriod: this.currentFilter,
      };

      this.updateStateUrl();
      this.updateMobileTabLabels();

      new Request.AjaxIO('updateFilters', {
         onSuccess: function (data) {
            $('loadingSpinner').set('src', window.shared_constants.BaseURI('SITE_IMAGE_BLANK'));
            if (data.html) {
               $E('.leaderboard-container').set('html', data.html);
            }
         }.bind(this),
      }).send(config);
   },

   updateStateUrl: function (option) {
      let state = { filter: this.currentFilter };

      history.replaceState(state, '', this.makeStateUrl(state));
   },

   /* Update the URL with the state of filters and sorts
    * (Modified from `teardown.js`)
    */
   makeStateUrl: function (state) {
      state = Object.merge(
         {
            filter: this.currentFilter,
         },
         state || {}
      );

      let url = new URI(this.baseURL);
      let newurl = url.setData(state).toString();
      return newurl;
   },
});
